import React from 'react';

import { useTranslation } from '@crehana/i18n';

import CouponField from './CouponField';

const Coupon: React.FC<{
  className?: string;
  couponCode?: string;
  handleApplyCoupon(coupon: { couponCode: string }): Promise<{
    success: boolean;
    errors: any;
  }>;
  handleRemoveCoupon: () => void;
  canApplyCouponOnfirstRender?: boolean;
}> = ({
  className,
  couponCode,
  handleApplyCoupon,
  handleRemoveCoupon,
  canApplyCouponOnfirstRender,
}) => {
  const { t } = useTranslation();
  const [coupon, setCoupon] = React.useState({
    couponErrorMessage: '',
    code: couponCode || '',
    couponApplied: false,
    couponValidate: false,
    btnDisabled: false,
    couponShow: false,
  });
  const [isPristine, setPristine] = React.useState<boolean>(!couponCode);

  const onApplyCoupon = () => {
    const { code } = coupon;

    if (code === '') {
      setCoupon({
        ...coupon,
        couponErrorMessage: t('INVALID_COUPON'),
      });
    } else {
      setCoupon({ ...coupon, btnDisabled: true, couponApplied: true });
      handleApplyCoupon({
        couponCode: code,
      })
        .then(({ success, errors }) => {
          if (success) {
            setCoupon({
              ...coupon,
              couponApplied: true,
              couponValidate: true,
            });
          } else {
            setCoupon({
              ...coupon,
              couponErrorMessage:
                (errors.length > 0 && errors[errors.length - 1].message) ||
                t('INVALID_COUPON'),
            });
          }
        })
        .catch(error => {
          setCoupon({
            ...coupon,
            couponErrorMessage: t('CATCH_MESSAGE_COUPON'),
          });
          console.error(error);
        });
    }
  };

  const onRemoveCoupon = () => {
    setCoupon({
      ...coupon,
      couponApplied: false,
      code: '',
      couponValidate: false,
    });
    handleRemoveCoupon();
  };

  const onChangeCoupon = (event: React.ChangeEvent<HTMLInputElement>) => {
    let couponInput = event.target.value.trim();

    if (isPristine) {
      setPristine(false);
    }

    couponInput = couponInput.toUpperCase();
    setCoupon({
      ...coupon,
      code: couponInput,
      couponErrorMessage: '',
      couponValidate: false,
    });
  };

  const onKeyPressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !coupon.btnDisabled) {
      onApplyCoupon();
    }
  };

  React.useEffect(() => {
    if (coupon.code && canApplyCouponOnfirstRender) {
      onApplyCoupon();
    }
  }, []);

  const { couponErrorMessage, code, couponApplied, couponValidate } = coupon;

  return (
    <CouponField
      className={className}
      couponApplied={couponApplied}
      onApplyCoupon={onApplyCoupon}
      couponCode={code}
      couponErrorMessage={couponErrorMessage}
      onChangeCoupon={onChangeCoupon}
      couponValidate={couponValidate}
      onRemoveCoupon={onRemoveCoupon}
      isPristine={isPristine}
      onKeyPressEnter={onKeyPressEnter}
    />
  );
};

export default Coupon;
